import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTDevHero from "./NFTDevHero";
import TheIncreasing from "./TheIncreasing";
import DesigningUnique from "./DesigningUnique";
import CustomNFTDesigns from "./CustomNFTDesigns";
import ByBridging from "./ByBridging";
import Conceptualization from "./Conceptualization";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function NFTDevelopment() {
  return (
    <>
      <Header />
      <NFTDevHero />
      <TheIncreasing />
      <DesigningUnique />
      <CustomNFTDesigns />
      <ByBridging />
      <Conceptualization />
      <WhyChoose />
      <Footer />
    </>
  );
}

export default NFTDevelopment;
